// src/data/EstruturaOrganizacional.js

// src/data/EstruturaOrganizacional.js

export const ESTRUTURA_ORGANIZACIONAL = [
  // Superintendência (SUP)
  {
    id: 'sup',
    codigo: 'SUP',
    nome: 'Superintendência',
    telefone: '(34) 3218-2578',
    email: 'superint.hc-ufu@ebserh.gov.br',
    nivel: 1,
    parent: null,
    searchText: 'SUP Superintendência'
  },
  
  // Setores da Superintendência
  {
    id: 'stgq',
    codigo: 'STGQ',
    nome: 'Setor de Gestão da Qualidade',
    telefone: '(34) 3218-2858',
    email: 'sequali.hc-ufu@ebserh.gov.br',
    nivel: 2,
    parent: 'sup',
    searchText: 'STGQ Setor de Gestão da Qualidade qualidade'
  },
  {
    id: 'segov',
    codigo: 'SEGOV',
    nome: 'Setor de Governança e Estratégia',
    telefone: '(34) 3218-2388',
    email: 'segov.hc-ufu@ebserh.gov.br',
    nivel: 2,
    parent: 'sup',
    searchText: 'SEGOV Setor de Governança e Estratégia governança estratégia'
  },
  {
    id: 'setisd',
    codigo: 'SETISD',
    nome: 'Setor de Tecnologia da Informação e Saúde Digital',
    telefone: '(34) 3218-2039',
    email: 'setisd.hc-ufu@ebserh.gov.br',
    nivel: 2,
    parent: 'sup',
    searchText: 'SETISD Setor de Tecnologia da Informação e Saúde Digital TI tecnologia informação saúde digital'
  },
  {
    id: 'stcor',
    codigo: 'STCOR',
    nome: 'Setor de Contratualização e Regulação',
    telefone: '(34) 3218-2144',
    email: 'stcor.hc-ufu@ebserh.gov.br',
    nivel: 2,
    parent: 'sup',
    searchText: 'STCOR Setor de Contratualização e Regulação contratualização regulação'
  },
  {
    id: 'sejur',
    codigo: 'SEJUR',
    nome: 'Setor Jurídico',
    telefone: null,
    email: 'sejur.hc-ufu@ebserh.gov.br',
    nivel: 2,
    parent: 'sup',
    searchText: 'SEJUR Setor Jurídico jurídico'
  },
  {
    id: 'cext',
    codigo: 'CEXT',
    nome: 'Comissão de Extensão',
    telefone: null,
    email: null,
    nivel: 2,
    parent: 'sup',
    searchText: 'CEXT Comissão de Extensão extensão'
  },
  
  // Unidades do STGQ
  {
    id: 'ugq',
    codigo: 'UGQ',
    nome: 'Unidade de Gestão da Qualidade',
    telefone: '(34) 3218-2858',
    email: 'uquali.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'stgq',
    searchText: 'UGQ Unidade de Gestão da Qualidade qualidade gestão'
  },
  {
    id: 'uvs',
    codigo: 'UVS',
    nome: 'Unidade de Vigilância em Saúde',
    telefone: '(34) 3218-2504',
    email: 'uvs.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'stgq',
    searchText: 'UVS Unidade de Vigilância em Saúde vigilância'
  },
  {
    id: 'usep',
    codigo: 'USEP',
    nome: 'Unidade de Segurança do Paciente',
    telefone: '(34) 3218-2760',
    email: 'usp.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'stgq',
    searchText: 'USEP Unidade de Segurança do Paciente segurança paciente'
  },
  
  // Unidades do SEGOV
  {
    id: 'uges',
    codigo: 'UGES',
    nome: 'Unidade de Gestão Estratégica',
    telefone: '(34) 3218-2578',
    email: 'uplan.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'segov',
    searchText: 'UGES Unidade de Gestão Estratégica estratégica planejamento'
  },
  {
    id: 'ugrci',
    codigo: 'UGRCI',
    nome: 'Unidade de Gestão de Riscos e Controles Internos',
    telefone: '(34) 3218-2438',
    email: 'ugrci.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'segov',
    searchText: 'UGRCI Unidade de Gestão de Riscos e Controles Internos riscos controles internos'
  },
  {
    id: 'uplan',
    codigo: 'UPLAN',
    nome: 'Unidade de Planejamento',
    telefone: null,
    email: null,
    nivel: 3,
    parent: 'segov',
    searchText: 'UPLAN Unidade de Planejamento planejamento'
  },
  
  // Unidades do SETISD
  {
    id: 'uisti',
    codigo: 'UISTI',
    nome: 'Unidade de Infraestrutura, Suporte e Segurança de Tecnologia da Informação',
    telefone: '(34) 3218-2322',
    email: 'uisti.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'setisd',
    searchText: 'UISTI Unidade de Infraestrutura Suporte e Segurança de Tecnologia da Informação infraestrutura suporte segurança TI'
  },
  {
    id: 'usid',
    codigo: 'USID',
    nome: 'Unidade de Sistemas de Informação e Inteligência de Dados',
    telefone: null,
    email: null,
    nivel: 3,
    parent: 'setisd',
    searchText: 'USID Unidade de Sistemas de Informação e Inteligência de Dados sistemas informação inteligência dados'
  },
  
  // Unidades do STCOR
  {
    id: 'uri',
    codigo: 'URI',
    nome: 'Unidade de Regulação Interna',
    telefone: null,
    email: null,
    nivel: 3,
    parent: 'stcor',
    searchText: 'URI Unidade de Regulação Interna regulação interna'
  },
  {
    id: 'ucon',
    codigo: 'UCON',
    nome: 'Unidade de Contratualização',
    telefone: '(34) 3218-2144',
    email: 'ucon.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'stcor',
    searchText: 'UCON Unidade de Contratualização contratualização contratos'
  },
  {
    id: 'ugia',
    codigo: 'UGIA',
    nome: 'Unidade de Gestão da Informação Assistencial',
    telefone: '(34) 3218-2672',
    email: 'ugiaest.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'stcor',
    searchText: 'UGIA Unidade de Gestão da Informação Assistencial informação assistencial'
  },
  {
    id: 'upia',
    codigo: 'UPIA',
    nome: 'Unidade de Processamento da Informação Assistencial',
    telefone: '(34) 3218-2551',
    email: 'upia.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'stcor',
    searchText: 'UPIA Unidade de Processamento da Informação Assistencial processamento informação assistencial'
  },
  
  // Gerência Administrativa (GAD)
  {
    id: 'gad',
    codigo: 'GAD',
    nome: 'Gerência Administrativa',
    telefone: '(34) 3218-2578',
    email: 'gad.hc-ufu@ebserh.gov.br',
    nivel: 1,
    parent: null,
    searchText: 'GAD Gerência Administrativa administrativa'
  },
  
  // Divisões da GAD
  {
    id: 'daf',
    codigo: 'DAF',
    nome: 'Divisão de Administração e Finanças',
    telefone: '(34) 3218-2259',
    email: 'daf.hc-ufu@ebserh.gov.br',
    nivel: 2,
    parent: 'gad',
    searchText: 'DAF Divisão de Administração e Finanças administração finanças'
  },
  {
    id: 'dlih',
    codigo: 'DLIH',
    nome: 'Divisão de Logística e Infraestrutura Hospitalar',
    telefone: '(34) 3218-2308',
    email: 'dlih.hc-ufu@ebserh.gov.br',
    nivel: 2,
    parent: 'gad',
    searchText: 'DLIH Divisão de Logística e Infraestrutura Hospitalar logística infraestrutura hospitalar'
  },
  {
    id: 'divgp',
    codigo: 'DIVGP',
    nome: 'Divisão de Gestão de Pessoas',
    telefone: '(34) 3218-2848',
    email: 'divgp.hc-ufu@ebserh.gov.br',
    nivel: 2,
    parent: 'gad',
    searchText: 'DIVGP Divisão de Gestão de Pessoas gestão pessoas recursos humanos RH'
  },
  
  // Setores da DAF
  {
    id: 'sgof',
    codigo: 'SGOF',
    nome: 'Setor de Gestão Orçamentária e Financeira',
    telefone: '(34) 3218-2259',
    email: 'sgof.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'daf',
    searchText: 'SGOF Setor de Gestão Orçamentária e Financeira orçamentária financeira orçamento'
  },
  {
    id: 'scont',
    codigo: 'SCONT',
    nome: 'Setor de Contabilidade',
    telefone: '(34) 3218-2015',
    email: 'scont.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'daf',
    searchText: 'SCONT Setor de Contabilidade contabilidade contábil'
  },
  {
    id: 'sad',
    codigo: 'SAD',
    nome: 'Setor de Administração',
    telefone: '(34) 3218-2401',
    email: 'adm.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'daf',
    searchText: 'SAD Setor de Administração administração'
  },
  
  // Unidades do SGOF
  {
    id: 'ueof',
    codigo: 'UEOF',
    nome: 'Unidade de Execução Orçamentária e Financeira',
    telefone: null,
    email: 'ueof.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'sgof',
    searchText: 'UEOF Unidade de Execução Orçamentária e Financeira execução orçamentária financeira'
  },
  {
    id: 'upgo',
    codigo: 'UPGO',
    nome: 'Unidade de Planejamento e Gestão Orçamentária',
    telefone: '(34) 3218-2259',
    email: 'upgo.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'sgof',
    searchText: 'UPGO Unidade de Planejamento e Gestão Orçamentária planejamento gestão orçamentária'
  },
  
  // Unidades do SAD
  {
    id: 'ul',
    codigo: 'UL',
    nome: 'Unidade de Licitações',
    telefone: '(34) 3218-2401, (34) 3218-2031 e (34) 3218-2029',
    email: 'ulic.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'sad',
    searchText: 'UL Unidade de Licitações licitações licitação compras'
  },
  {
    id: 'upat',
    codigo: 'UPAT',
    nome: 'Unidade de Patrimônio',
    telefone: '(34) 3218-2035',
    email: 'upat.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'sad',
    searchText: 'UPAT Unidade de Patrimônio patrimônio bens patrimoniais'
  },
  {
    id: 'ucont',
    codigo: 'UCONT',
    nome: 'Unidade de Contratos',
    telefone: '(34) 3218-2742',
    email: 'ucont.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'sad',
    searchText: 'UCONT Unidade de Contratos contratos'
  },
  {
    id: 'ufac',
    codigo: 'UFAC',
    nome: 'Unidade de Fiscalização Administrativa de Contratos',
    telefone: '(34) 3218-2742',
    email: 'ufac.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'sad',
    searchText: 'UFAC Unidade de Fiscalização Administrativa de Contratos fiscalização administrativa contratos'
  },
  {
    id: 'upc',
    codigo: 'UPC',
    nome: 'Unidade de Planejamento de Compras',
    telefone: '(34) 3218-2401',
    email: 'upc.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'sad',
    searchText: 'UPC Unidade de Planejamento de Compras planejamento compras'
  },
  
  // Setores da DLIH
  {
    id: 'stec',
    codigo: 'STEC',
    nome: 'Setor de Engenharia Clínica',
    telefone: '(34) 3218-2171',
    email: 'stec.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dlih',
    searchText: 'STEC Setor de Engenharia Clínica engenharia clínica equipamentos médicos'
  },
  {
    id: 'sthh',
    codigo: 'STHH',
    nome: 'Setor de Hotelaria Hospitalar',
    telefone: '(34) 3218-2686',
    email: 'shh.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dlih',
    searchText: 'STHH Setor de Hotelaria Hospitalar hotelaria hospitalar'
  },
  {
    id: 'sif',
    codigo: 'SIF',
    nome: 'Setor de Infraestrutura Física',
    telefone: '(34) 3218-2171',
    email: 'siffp.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dlih',
    searchText: 'SIF Setor de Infraestrutura Física infraestrutura física'
  },
  {
    id: 'safs',
    codigo: 'SAFS',
    nome: 'Setor de Abastecimento Farmacêutico e Suprimentos',
    telefone: '(34) 3218-2192',
    email: 'sesup.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dlih',
    searchText: 'SAFS Setor de Abastecimento Farmacêutico e Suprimentos abastecimento farmacêutico suprimentos farmácia'
  },
  {
    id: 'usop',
    codigo: 'USOP',
    nome: 'Unidade de Suporte Operacional',
    telefone: '(34) 3218-2388',
    email: 'usg.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dlih',
    searchText: 'USOP Unidade de Suporte Operacional suporte operacional'
  },
  
  // Unidades do STHH
  {
    id: 'uhosp',
    codigo: 'UHOSP',
    nome: 'Unidade de Hospitalidade',
    telefone: '(34) 3218-2388',
    email: 'uhosp.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'sthh',
    searchText: 'UHOSP Unidade de Hospitalidade hospitalidade'
  },
  {
    id: 'updr',
    codigo: 'UPDR',
    nome: 'Unidade de Produção e Distribuição de Refeições',
    telefone: '(34) 3218-2624',
    email: 'updr.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'sthh',
    searchText: 'UPDR Unidade de Produção e Distribuição de Refeições produção distribuição refeições alimentação'
  },
  
  // Unidades do SIF
  {
    id: 'ump',
    codigo: 'UMP',
    nome: 'Unidade de Manutenção Predial',
    telefone: null,
    email: 'ump.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'sif',
    searchText: 'UMP Unidade de Manutenção Predial manutenção predial'
  },
  {
    id: 'upo',
    codigo: 'UPO',
    nome: 'Unidade de Projetos e Obras',
    telefone: '(34) 3218-2308',
    email: 'upo.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'sif',
    searchText: 'UPO Unidade de Projetos e Obras projetos obras'
  },
  
  // Unidades do SAFS
  {
    id: 'upde',
    codigo: 'UPDE',
    nome: 'Unidade de Planejamento e Dimensionamento de Estoques',
    telefone: '(34) 3218-2390',
    email: 'upde.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'safs',
    searchText: 'UPDE Unidade de Planejamento e Dimensionamento de Estoques planejamento dimensionamento estoques'
  },
  {
    id: 'uace',
    codigo: 'UACE',
    nome: 'Unidade de Almoxarifado e Controle de Estoque',
    telefone: null,
    email: null,
    nivel: 4,
    parent: 'safs',
    searchText: 'UACE Unidade de Almoxarifado e Controle de Estoque almoxarifado controle estoques'
  },
  
  // Unidades da DIVGP
  {
    id: 'uap',
    codigo: 'UAP',
    nome: 'Unidade de Administração de Pessoal',
    telefone: '(34) 3218-2848',
    email: 'uap.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'divgp',
    searchText: 'UAP Unidade de Administração de Pessoal administração pessoal RH'
  },
  {
    id: 'udp',
    codigo: 'UDP',
    nome: 'Unidade de Desenvolvimento de Pessoal',
    telefone: '(34) 3218-2758',
    email: 'udp.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'divgp',
    searchText: 'UDP Unidade de Desenvolvimento de Pessoal desenvolvimento pessoal capacitação treinamento'
  },
  {
    id: 'usost',
    codigo: 'USOST',
    nome: 'Unidade de Saúde Ocupacional e Segurança do Trabalho',
    telefone: '(34) 3218-2412',
    email: 'sost.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'divgp',
    searchText: 'USOST Unidade de Saúde Ocupacional e Segurança do Trabalho saúde ocupacional segurança trabalhador SESMT'
  },
  
  // Gerência de Atenção à Saúde (GAS)
  {
    id: 'gas',
    codigo: 'GAS',
    nome: 'Gerência de Atenção à Saúde',
    telefone: '(34) 3218-2578',
    email: 'gas.hc-ufu@ebserh.gov.br',
    nivel: 1,
    parent: null,
    searchText: 'GAS Gerência de Atenção à Saúde atenção saúde assistencial'
  },
  
  // Divisões da GAS
  {
    id: 'dmed',
    codigo: 'DMED',
    nome: 'Divisão Médica',
    telefone: '(34) 3218-2706',
    email: 'dmed.hc-ufu@ebserh.gov.br',
    nivel: 2,
    parent: 'gas',
    searchText: 'DMED Divisão Médica médica'
  },
  {
    id: 'dadt',
    codigo: 'DADT',
    nome: 'Divisão de Apoio Diagnóstico e Terapêutico',
    telefone: '(34) 3218-2858',
    email: 'dadt.hc-ufu@ebserh.gov.br',
    nivel: 2,
    parent: 'gas',
    searchText: 'DADT Divisão de Apoio Diagnóstico e Terapêutico apoio diagnóstico terapêutico'
  },
  {
    id: 'dgc',
    codigo: 'DGC',
    nome: 'Divisão de Gestão do Cuidado',
    telefone: '(34) 3218-2578',
    email: 'dgc.hc-ufu@ebserh.gov.br',
    nivel: 2,
    parent: 'gas',
    searchText: 'DGC Divisão de Gestão do Cuidado gestão cuidado'
  },
  {
    id: 'denf',
    codigo: 'DENF',
    nome: 'Divisão de Enfermagem',
    telefone: '(34) 3218-2706',
    email: 'denf.hc-ufu@ebserh.gov.br',
    nivel: 2,
    parent: 'gas',
    searchText: 'DENF Divisão de Enfermagem enfermagem'
  },
  
  // Setores da DMED
  {
    id: 'stesp',
    codigo: 'STESP',
    nome: 'Setor de Cuidados Especializados',
    telefone: '(34) 3291-6161',
    email: 'stesp.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dmed',
    searchText: 'STESP Setor de Cuidados Especializados cuidados especializados'
  },
  
  // Unidades do STESP
  {
    id: 'uhh',
    codigo: 'UHH',
    nome: 'Unidade de Hematologia e Hemoterapia',
    telefone: '(34) 3291-6161',
    email: 'stesp.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'stesp',
    searchText: 'UHH Unidade de Hematologia e Hemoterapia hematologia hemoterapia sangue'
  },
  {
    id: 'uonc',
    codigo: 'UONC',
    nome: 'Unidade de Oncologia',
    telefone: '(34) 3291-6161',
    email: 'stesp.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'stesp',
    searchText: 'UONC Unidade de Oncologia oncologia câncer'
  },
  
  // Setores da DADT
  {
    id: 'sfh',
    codigo: 'SFH',
    nome: 'Setor de Farmácia Hospitalar',
    telefone: '(34) 3218-2390',
    email: 'sefar.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dadt',
    searchText: 'SFH Setor de Farmácia Hospitalar farmácia hospitalar medicamentos'
  },
  {
    id: 'stdt',
    codigo: 'STDT',
    nome: 'Setor de Apoio Diagnóstico e Terapêutico',
    telefone: '(34) 3218-2216',
    email: 'stdt.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dadt',
    searchText: 'STDT Setor de Apoio Diagnóstico e Terapêutico apoio diagnóstico terapêutico'
  },
  
  // Unidades do SFH
  {
    id: 'ufcd',
    codigo: 'UFCD',
    nome: 'Unidade de Farmácia Clínica e Dispensação Farmacêutica',
    telefone: '(34) 3218-2390',
    email: 'ufcd.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'sfh',
    searchText: 'UFCD Unidade de Farmácia Clínica e Dispensação Farmacêutica farmácia clínica dispensação'
  },
  
  // Unidades do STDT
  {
    id: 'unut',
    codigo: 'UNUT',
    nome: 'Unidade de Nutrição Clínica',
    telefone: '(34) 3218-2130',
    email: 'unut.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'stdt',
    searchText: 'UNUT Unidade de Nutrição Clínica nutrição clínica'
  },
  {
    id: 'udi',
    codigo: 'UDI',
    nome: 'Unidade de Diagnóstico por Imagem',
    telefone: '(34) 3218-2162',
    email: 'tomografia.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'stdt',
    searchText: 'UDI Unidade de Diagnóstico por Imagem diagnóstico imagem raio-x tomografia ressonância'
  },
  {
    id: 'ureab',
    codigo: 'UREAB',
    nome: 'Unidade de Reabilitação',
    telefone: '(34) 3218-2111',
    email: 'ureab.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'stdt',
    searchText: 'UREAB Unidade de Reabilitação reabilitação fisioterapia'
  },
  {
    id: 'ubcme',
    codigo: 'UBCME',
    nome: 'Unidade de Bloco Cirúrgico e Processamento Material Esterilizado',
    telefone: '(34) 3218-2111',
    email: 'ubcme.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'stdt',
    searchText: 'UBCME Unidade de Bloco Cirúrgico e Processamento Material Esterilizado bloco cirúrgico centro cirúrgico esterilização'
  },
  {
    id: 'utiad',
    codigo: 'UTIAD',
    nome: 'Unidade de Terapia Intensiva Adulto',
    telefone: '(34) 3218-2111',
    email: 'utiad.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'stdt',
    searchText: 'UTIAD Unidade de Terapia Intensiva Adulto UTI adulto terapia intensiva'
  },
  {
    id: 'uapat',
    codigo: 'UAPAT',
    nome: 'Unidade de Anatomia Patológica',
    telefone: '(34) 3218-2111',
    email: 'uapat.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'stdt',
    searchText: 'UAPAT Unidade de Anatomia Patológica anatomia patológica patologia'
  },
  {
    id: 'ulac',
    codigo: 'ULAC',
    nome: 'Unidade de Laboratório de Análises Clínicas',
    telefone: '(34) 3218-2152',
    email: 'ulacadm.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'stdt',
    searchText: 'ULAC Unidade de Laboratório de Análises Clínicas laboratório análises clínicas exames'
  },
  
  // Setores da DGC
  {
    id: 'stpc',
    codigo: 'STPC',
    nome: 'Setor de Paciente Crítico',
    telefone: null,
    email: 'stpc.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dgc',
    searchText: 'STPC Setor de Paciente Crítico paciente crítico'
  },
  
  // Unidades da DGC e STPC
  {
    id: 'uue',
    codigo: 'UUE',
    nome: 'Unidade de Urgência e Emergência',
    telefone: '(34) 3218-2290',
    email: 'uue.hc-ufu@ebserh.gov.br',
    nivel: 4,
    parent: 'stpc',
    searchText: 'UUE Unidade de Urgência e Emergência urgência emergência pronto socorro'
  },
  {
    id: 'usur',
    codigo: 'USUR',
    nome: 'Unidade de Sistema Urinário',
    telefone: '(34) 3218-2071',
    email: 'usur.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dgc',
    searchText: 'USUR Unidade de Sistema Urinário sistema urinário nefrologia urologia'
  },
  {
    id: 'ucap',
    codigo: 'UCAP',
    nome: 'Unidade de Cabeça e Pescoço',
    telefone: '(34) 3218-2578',
    email: 'ucap.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dgc',
    searchText: 'UCAP Unidade de Cabeça e Pescoço cabeça pescoço otorrinolaringologia'
  },
  {
    id: 'uadcp',
    codigo: 'UADCP',
    nome: 'Unidade de Atenção Domiciliar e dos Cuidados Paliativos',
    telefone: '(34) 3218-2560',
    email: 'uadcp.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dgc',
    searchText: 'UADCP Unidade de Atenção Domiciliar e dos Cuidados Paliativos atenção domiciliar cuidados paliativos'
  },
  {
    id: 'ucm',
    codigo: 'UCM',
    nome: 'Unidade de Clínica Médica',
    telefone: '(34) 3218-2706',
    email: 'uec.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dgc',
    searchText: 'UCM Unidade de Clínica Médica clínica médica especialidades clínicas'
  },
  {
    id: 'uca',
    codigo: 'UCA',
    nome: 'Unidade da Criança e do Adolescente',
    telefone: '(34) 3218-2022',
    email: 'uca.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dgc',
    searchText: 'UCA Unidade da Criança e do Adolescente criança adolescente pediatria'
  },
  {
    id: 'utin',
    codigo: 'UTIN',
    nome: 'Unidade de Terapia Intensiva Neonatal',
    telefone: '(34) 3218-2454',
    email: 'utin.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dgc',
    searchText: 'UTIN Unidade de Terapia Intensiva Neonatal UTI neonatal recém-nascido'
  },
  {
    id: 'usme',
    codigo: 'USME',
    nome: 'Unidade de Saúde Mental',
    telefone: '(34) 3218-2244',
    email: 'usme.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dgc',
    searchText: 'USME Unidade de Saúde Mental saúde mental psiquiatria psicologia'
  },
  {
    id: 'ucir',
    codigo: 'UCIR',
    nome: 'Unidade de Clínica Cirúrgica',
    telefone: '(34) 3218-2022',
    email: 'ucir.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dgc',
    searchText: 'UCIR Unidade de Clínica Cirúrgica clínica cirúrgica cirurgia'
  },
  {
    id: 'usne',
    codigo: 'USNE',
    nome: 'Unidade de Sistema Nervoso',
    telefone: '(34) 3218-2022',
    email: 'usne.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dgc',
    searchText: 'USNE Unidade de Sistema Nervoso sistema nervoso neurologia neurocirurgia'
  },
  {
    id: 'usd',
    codigo: 'USD',
    nome: 'Unidade do Sistema Digestivo',
    telefone: '(34) 3218-2111',
    email: 'usd.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dgc',
    searchText: 'USD Unidade do Sistema Digestivo sistema digestivo gastroenterologia'
  },
  {
    id: 'umul',
    codigo: 'UMUL',
    nome: 'Unidade de Saúde da Mulher',
    telefone: '(34) 3218-2706',
    email: 'umul.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dgc',
    searchText: 'UMUL Unidade de Saúde da Mulher saúde da mulher ginecologia obstetrícia'
  },
  {
    id: 'uscv',
    codigo: 'USCV',
    nome: 'Unidade do Sistema Cardiovascular',
    telefone: '(34) 3218-2111',
    email: 'uscv.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dgc',
    searchText: 'USCV Unidade do Sistema Cardiovascular sistema cardiovascular cardiologia'
  },
  {
    id: 'ures',
    codigo: 'URES',
    nome: 'Unidade do Sistema Respiratório',
    telefone: '(34) 3218-2111',
    email: 'ures.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dgc',
    searchText: 'URES Unidade do Sistema Respiratório sistema respiratório pneumologia'
  },
  {
    id: 'uto',
    codigo: 'UTO',
    nome: 'Unidade de Traumato-Ortopedia',
    telefone: '(34) 3218-2706',
    email: 'uto.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'dgc',
    searchText: 'UTO Unidade de Traumato-Ortopedia traumato ortopedia trauma ortopédica'
  },
  
  // Unidades da DENF
  {
    id: 'uagenf',
    codigo: 'UAGENF',
    nome: 'Unidade de Apoio à Gestão e Enfermagem',
    telefone: '(34) 3218-2146',
    email: 'uagenf.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'denf',
    searchText: 'UAGENF Unidade de Apoio à Gestão e Enfermagem apoio gestão enfermagem'
  },
  
  // Gerência de Ensino e Pesquisa (GEP)
  {
    id: 'gep',
    codigo: 'GEP',
    nome: 'Gerência de Ensino e Pesquisa',
    telefone: '(34) 3218-2706',
    email: 'gep.hc-ufu@ebserh.gov.br',
    nivel: 1,
    parent: null,
    searchText: 'GEP Gerência de Ensino e Pesquisa ensino pesquisa'
  },
  
  // Unidades diretas da GEP
  {
    id: 'ues',
    codigo: 'UES',
    nome: 'Unidade de e-Saúde',
    telefone: '(34) 3218-2706',
    email: 'ues.hc-ufu@ebserh.gov.br',
    nivel: 2,
    parent: 'gep',
    searchText: 'UES Unidade de e-Saúde e-saúde telemedicina'
  },
  
  // Setores da GEP
  {
    id: 'sege',
    codigo: 'SEGE',
    nome: 'Setor de Gestão de Ensino',
    telefone: '(34) 3218-2706',
    email: 'sege.hc-ufu@ebserh.gov.br',
    nivel: 2,
    parent: 'gep',
    searchText: 'SEGE Setor de Gestão de Ensino gestão ensino'
  },
  {
    id: 'sgpits',
    codigo: 'SGPITS',
    nome: 'Setor de Gestão da Pesquisa e da Inovação Tecnológica em Saúde',
    telefone: '(34) 3218-2706',
    email: 'sgpits.hc-ufu@ebserh.gov.br',
    nivel: 2,
    parent: 'gep',
    searchText: 'SGPITS Setor de Gestão da Pesquisa e da Inovação Tecnológica em Saúde gestão pesquisa inovação tecnológica'
  },
  
  // Unidades do SEGE
  {
    id: 'ugete',
    codigo: 'UGETE',
    nome: 'Unidade de Gestão de Graduação, Ensino Técnico e Extensão',
    telefone: '(34) 3218-2072',
    email: 'ugete.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'sege',
    searchText: 'UGETE Unidade de Gestão de Graduação Ensino Técnico e Extensão graduação ensino técnico extensão'
  },
  {
    id: 'ugpos',
    codigo: 'UGPOS',
    nome: 'Unidade de Gestão de Pós-Graduação',
    telefone: '(34) 3218-2067',
    email: 'ugpos.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'sege',
    searchText: 'UGPOS Unidade de Gestão de Pós-Graduação pós-graduação especialização residência'
  },
  
  // Unidades do SGPITS
  {
    id: 'ugpesq',
    codigo: 'UGPESQ',
    nome: 'Unidade de Gestão da Pesquisa',
    telefone: '(34) 3218-2323',
    email: 'ugpesq.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'sgpits',
    searchText: 'UGPESQ Unidade de Gestão da Pesquisa gestão pesquisa'
  },
  {
    id: 'ugits',
    codigo: 'UGITS',
    nome: 'Unidade de Gestão da Inovação Tecnológica em Saúde',
    telefone: '(34) 3218-2323',
    email: 'ugits.hc-ufu@ebserh.gov.br',
    nivel: 3,
    parent: 'sgpits',
    searchText: 'UGITS Unidade de Gestão da Inovação Tecnológica em Saúde gestão inovação tecnológica'
  },
  
  // Ouvidoria
  {
    id: 'ouv',
    codigo: 'OUV',
    nome: 'Ouvidoria',
    telefone: '(34) 3218-2635',
    email: 'ouv.hc-ufu@ebserh.gov.br',
    nivel: 1,
    parent: null,
    searchText: 'OUV Ouvidoria ouvidoria'
  },
  
  // Unidade de Comunicação Social (adicionada da primeira lista)
  {
    id: 'ucs',
    codigo: 'UCS',
    nome: 'Unidade de Comunicação Social',
    telefone: null,
    email: null,
    nivel: 2,
    parent: null,
    searchText: 'UCS Unidade de Comunicação Social comunicação social'
  }
];

// Função auxiliar para buscar unidades organizacionais
export const searchUnidades = (searchText) => {
  if (!searchText || searchText.trim().length < 2) {
    return ESTRUTURA_ORGANIZACIONAL;
  }
  
  const normalizedSearch = searchText
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, ''); // Remove acentos
  
  return ESTRUTURA_ORGANIZACIONAL.filter(unidade => {
    const searchableText = unidade.searchText
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    
    return searchableText.includes(normalizedSearch);
  });
};

// Função para obter hierarquia completa de uma unidade
export const getUnidadeHierarchy = (unidadeId) => {
  const unidade = ESTRUTURA_ORGANIZACIONAL.find(u => u.id === unidadeId);
  if (!unidade) return '';
  
  const hierarchy = [unidade];
  let current = unidade;
  
  while (current.parent) {
    const parent = ESTRUTURA_ORGANIZACIONAL.find(u => u.id === current.parent);
    if (parent) {
      hierarchy.unshift(parent);
      current = parent;
    } else {
      break;
    }
  }
  
  return hierarchy.map(u => u.codigo).join(' > ');
};

// Função para formatar unidade para exibição
export const formatUnidadeDisplay = (unidade) => {
  return `${unidade.codigo} - ${unidade.nome}`;
};

// ✅ CORRIGIDO - Lista de avaliadores com IDs únicos e nomes reais

export const AVALIADORES = [
  { id: 'av01', nome: 'Adriana Oliveira Nogueira Monteiro', login: 'adriana-monteiro.am@ebserh.gov.br', level: 'membro' },
  { id: 'av02', nome: 'Alcileia Morais Ferreira', login: 'alcileia.ferreira@ebserh.gov.br', level: 'membro' },
  { id: 'av03', nome: 'Aline Simão Alves', login: 'aline.simao@ebserh.gov.br', level: 'membro' },
  { id: 'av04', nome: 'Andre Luis Lopes Saraiva', login: 'andre.saraiva@ebserh.gov.br', level: 'membro' },
  { id: 'av05', nome: 'Anna Luiza Moreira dos Santos Albernaz', login: 'anna.albernaz@ebserh.gov.br', level: 'coordenacao' },
  { id: 'av06', nome: 'Carolline Viana Herrera', login: 'carolline.viana@ebserh.gov.br', level: 'membro' },
  { id: 'av07', nome: 'Cecília Pereira Reis', login: 'ceciliareis.hctm@ebserh.gov.br', level: 'membro' },
  { id: 'av08', nome: 'Elisângela Souto Fernandes', login: 'elisangela.fernandes@ebserh.gov.br', level: 'membro' },
  { id: 'av09', nome: 'Fabiana Cristina Rodrigues Rosa Cedro', login: 'fabiana.cedro@ebserh.gov.br', level: 'membro' },
  { id: 'av10', nome: 'Felipe Pereira Marra Gomes', login: 'felipe.marra@ebserh.gov.br', level: 'membro' },
  { id: 'av11', nome: 'Fernanda Dias Leão', login: 'leao.fernanda@ebserh.gov.br', level: 'membro' },
  { id: 'av12', nome: 'Flávio Marinho Narici', login: 'flavio.narici@ebserh.gov.br', level: 'membro' },
  { id: 'av13', nome: 'Francisco Diego Negrão Lopes Neto', login: 'francisco.negrao@ebserh.gov.br', level: 'programador' },
  { id: 'av14', nome: 'Gizete Cavalcante Pina De Almeida', login: 'gizete.almeida@ebserh.gov.br', level: 'membro' },
  { id: 'av15', nome: 'Ianny Angélica Barbosa Gusmão', login: 'ianny.gusmao@ebserh.gov.br', level: 'membro' },
  { id: 'av16', nome: 'Jaqueline De Moraes Ananias Andrade', login: 'jaqueline.ananias@ebserh.gov.br', level: 'membro' },
  { id: 'av17', nome: 'Marcos Antônio Rodrigues Florêncio', login: 'marcos.florencio@ebserh.gov.br', level: 'programador' },
  { id: 'av18', nome: 'Marjory Cristina Donato', login: 'marjory.donato@ebserh.gov.br', level: 'membro' },
  { id: 'av19', nome: 'Rúbia Graciele Silva', login: 'rubia.graciele@ebserh.gov.br', level: 'membro' },
  { id: 'av20', nome: 'Scarlat Ferreira Piqui', login: 'scarlat.piqui@ebserh.gov.br', level: 'membro' },
  { id: 'av21', nome: 'Sheila Ferreira Freire', login: 'sheilla.freire@ebserh.gov.br', level: 'membro' },
  { id: 'av22', nome: 'Sueli Santos Pereira Silva', login: 'sueli.silva.2@ebserh.gov.br', level: 'membro' },
  { id: 'av23', nome: 'Thiago Henrique Pereira Nunes', login: 'thiago.nunes@ebserh.gov.br', level: 'membro' },
  { id: 'av24', nome: 'Vanessa Carla De Souza Pereira', login: 'vanessa.souza@ebserh.gov.br', level: 'membro' },
  { id: 'av999', nome: '⚠️_Avaliador_Sem Dupla', login: 'avaliadorsemdupla@ebserh.gov.br', level: 'membro', isSpecial: true }

];


// Avaliador padrão (usado quando não há um selecionado)
export const DEFAULT_AVALIADOR = AVALIADORES[1]; // Sem nome

// Função para buscar avaliador por ID
export const getAvaliadorById = (id) => {
  return AVALIADORES.find(a => a.id === id) || DEFAULT_AVALIADOR;
};

// Função para buscar avaliador por login
export const getAvaliadorByLogin = (login) => {
  return AVALIADORES.find(a => a.login === login) || DEFAULT_AVALIADOR;
};

// Função para obter o emoji do nível do avaliador
export const getLevelEmoji = (level) => {
  switch(level) {
    case 'coordenacao': return '👑'; // Coroa para coordenação
    case 'programador': return '💻'; // Computador para programador
    case 'membro': return '👤'; // Pessoa para membro comum
    default: return '👤'; // Padrão
  }
};

// Função para obter a descrição do nível
export const getLevelDescription = (level) => {
  switch(level) {
    case 'coordenacao': return 'Coordenadora';
    case 'programador': return 'Membro/Programação';
    case 'membro': return 'Membro da Comissão';
    default: return 'Membro';
  }
};

export default {
  AVALIADORES,
  DEFAULT_AVALIADOR,
  getAvaliadorById,
  getAvaliadorByLogin,
  getLevelEmoji,
  getLevelDescription
};